export enum ApplicationType {
  IntoStudy = 'IntoStudy',
  PartnerPortal = 'PartnerPortal',
  UniBrandedB2c = 'UniBrandedB2c',
}
